import { useAddSourceMutation, useAddVerificationMutation, useUpdateSourceMutation } from 'entities/Source';

export const useUpdateSource = () => {
	const [addSource, { data: createData, isLoading: isCreateLoading, isSuccess: isCreateSuccess, error: createError }] =
		useAddSourceMutation();

	const [
		updateSource,
		{ data: updateData, isLoading: isUpdateLoading, isSuccess: isUpdateSuccess, error: updateError },
	] = useUpdateSourceMutation();

	const [addVerification, { isLoading: isVerificationLoading, isSuccess: isVerificationSuccess }] =
		useAddVerificationMutation();

	return {
		addSource,
		updateSource,
		addVerification,
		data: createData || updateData,
		isLoading: isCreateLoading || isUpdateLoading || isVerificationLoading,
		isSuccess: isCreateSuccess || isUpdateSuccess,
		isVerificationSuccess,
		error: createError || updateError,
	};
};
